import React from 'react';
import { LogOut, User, Truck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import NotificationBell from '@/components/NotificationBell';
import { InstallAppButton } from '@/components/InstallAppPrompt';

const DashboardLayout = ({ children, title, onNotificationClick }) => {
  const { empresa, usuario, logout } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  
  const getPerfilLabel = (perfil) => {
    const labels = {
      super_admin: 'Super Admin',
      master_admin: 'Master Admin',
      cliente: 'Cliente',
      entregador: 'Entregador',
      funcionario: 'Funcionário'
    };
    return labels[perfil] || perfil;
  };
  
  // Mostra notificações apenas para entregadores
  const showNotifications = usuario?.perfil === 'entregador';
  // Mostra botão de instalar para entregadores e funcionários
  const showInstallButton = usuario?.perfil === 'entregador' || usuario?.perfil === 'funcionario';
  
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src="/logo-rota017.png" alt="Rota 017" className="w-10 h-10 rounded-xl object-cover" />
            <div>
              <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>
                {title}
              </h1>
              <p className="text-sm text-slate-600">{empresa?.nome_fantasia || empresa?.razao_social}</p>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            {showInstallButton && <InstallAppButton />}
            
            {showNotifications && (
              <NotificationBell onNotificationClick={onNotificationClick} />
            )}
            
            <div className="text-right hidden sm:block">
              <p className="text-sm font-medium text-slate-900">{usuario?.nome}</p>
              <p className="text-xs text-slate-600">{getPerfilLabel(usuario?.perfil)}</p>
            </div>
            <Button
              data-testid="logout-button"
              variant="outline"
              size="sm"
              onClick={handleLogout}
              className="gap-2 border-orange-200 text-orange-600 hover:bg-orange-50"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden sm:inline">Sair</span>
            </Button>
          </div>
        </div>
      </header>
      
      {/* Content */}
      <main className="max-w-7xl mx-auto px-6 py-8">
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;
